import { Button, Card, InputGroup } from '@blueprintjs/core';

import cls from './Filter.module.css';

interface SearchFilterCardProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  className?: string;
  placeholder?: string;
}
export function SearchFilterCard({ className, label, placeholder, value, onChange }: SearchFilterCardProps) {
  const onInputChange = event => {
    onChange(event.target.value);
  };

  const onInputClear = () => {
    onChange('');
  };

  return (
    <Card className={className}>
      <small className={cls.label}>{label.toUpperCase()}</small>
      <div>
        <InputGroup
          className={cls.input}
          name="text"
          placeholder={placeholder ?? 'Search...'}
          rightElement={
            value ? (
              <Button minimal icon="cross" onClick={onInputClear} />
            ) : (
              <Button minimal type="submit" icon="search" />
            )
          }
          value={value}
          onChange={onInputChange}
        />
      </div>
    </Card>
  );
}
